module.exports = __webpack_public_path__ + "static/media/05.f782d8b4.mp3";